import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MerchantApi} from "../../../../common/apis/merchant-api";
import {Merchant} from "../../../../common/interfaces/Merchant";

@Component({
  selector: 'featured-chefs',
  templateUrl: './featured-chefs.component.html',
  styleUrls: ['./featured-chefs.component.scss']
})
export class FeaturedChefsComponent implements AfterViewInit, OnInit {

  @ViewChild('featuredChefsItemsContainer') container: ElementRef
  merchants: Merchant[] = []

  constructor(
    private merchantApi: MerchantApi
  ) {
  }

  ngOnInit(): void {
    this.merchantApi.getMerchants(1).subscribe({
      next: (merchantsResponse) => {
        this.merchants = merchantsResponse.data
        if (this.merchants.isNotEmpty()) {
          while (this.merchants.length < 10) {
            this.merchants.push(...merchantsResponse.data)
          }
        }
      },
    })
  }

  ngAfterViewInit(): void {
    this.container.nativeElement.scrollLeft = this.container.nativeElement.scrollWidth
    setInterval(() => {
      this.container.nativeElement.scrollLeft -= 1
      if (this.container.nativeElement.scrollLeft === 0) {
        this.container.nativeElement.scrollLeft = this.container.nativeElement.scrollWidth
      }
    }, 50);
  }

}
